// extracted by mini-css-extract-plugin
export default {"success":"CandidateInterviewOpinion_success__1fo9t"};